var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 470,
    height: 249,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 0h464a3 3 0 0 1 3 3v246H0V3a3 3 0 0 1 3-3z",
    fill: "#E5E5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.18 84.003h-76.718c-5.778 0-10.462 4.67-10.462 10.433v48.69c0 5.761 4.684 10.433 10.462 10.433h76.718c5.778 0 10.462-4.672 10.462-10.434v-48.69c0-5.761-4.684-10.432-10.462-10.432zm3.487 40.293l-21.945-21.885a3.494 3.494 0 0 0-4.93 0l-28.92 28.84L213.39 119.8a3.494 3.494 0 0 0-4.931 0l-11.484 11.453V94.436a3.483 3.483 0 0 1 3.488-3.478h76.718a3.483 3.483 0 0 1 3.487 3.478v29.86z",
    fill: "#C7C7CC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7C7CC",
    d: "M274.631 68.003l6.364 6.363-92.631 92.631-6.364-6.363z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5EA",
    d: "M279.631 73.003l6.364 6.363-92.631 92.631-6.364-6.363z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultHome);
export default __webpack_public_path__ + "static/media/default-home.1386e48b9933f62abf07885acb1c011b.svg";
export { ForwardRef as ReactComponent };